export class Permissions {
  public static readonly getAllServers = { action: 'Servers', type: 'GetAll' };
  public static readonly getAllConnections = { action: 'Connections', type: 'GetAll' };
  public static readonly getAllRolePermissions = { action: 'RolePermissions', type: 'GetAll' };
  public static readonly getAllDevices = { action: 'Devices', type: 'GetAll' };
  public static readonly getAllClients = { action: 'Clients', type: 'GetAll' };
  public static readonly getAllScripts = { action: 'Scripts', type: 'GetAll' };
  public static readonly reindexTickets = { action: 'Tickets', type: 'Reindex' };
}
